"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTeamLeaderProperty = exports.teamLeaderPropertyDefinition = void 0;
exports.teamLeaderPropertyDefinition = {
    view: {
        label: 'Team leader',
        hint: 'CEO, Captain, Manager, Owner or Leader of the team.',
    },
    constraints: [
        {
            name: 'maxLength',
            argument: 50,
        },
    ],
    type: 'text',
    multiple: false,
    name: 'team-leader',
};
const isTeamLeaderProperty = (prop) => {
    return prop.name === exports.teamLeaderPropertyDefinition.name;
};
exports.isTeamLeaderProperty = isTeamLeaderProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGVhbS1sZWFkZXIucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy90ZWFtLWxlYWRlci5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLDRCQUE0QixHQUFHO0lBQzFDLElBQUksRUFBRTtRQUNKLEtBQUssRUFBRSxhQUFhO1FBQ3BCLElBQUksRUFBRSxxREFBcUQ7S0FDNUQ7SUFDRCxXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxXQUFXO1lBQ2pCLFFBQVEsRUFBRSxFQUFFO1NBQ2I7S0FDRjtJQUNELElBQUksRUFBRSxNQUFNO0lBQ1osUUFBUSxFQUFFLEtBQUs7SUFDZixJQUFJLEVBQUUsYUFBYTtDQUNZLENBQUE7QUFJMUIsTUFBTSxvQkFBb0IsR0FBRyxDQUFDLElBQWtCLEVBQThCLEVBQUU7SUFDckYsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLG9DQUE0QixDQUFDLElBQUksQ0FBQTtBQUN4RCxDQUFDLENBQUE7QUFGWSxRQUFBLG9CQUFvQix3QkFFaEMifQ==